import { MuiF } from '../../../../../../Mui/F/Function/module/MuiF.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopAppCommunityF } from '../../../../Community/F/Function/module/MShopAppCommunityF.js';
import { frame } from './frame.js';
import querystring from 'querystring';
import { $find } from 'fxdom/es';

/*
 * 서버사이드 렌더링 후 프론트에서 이니셜라이즈 하는 함수입니다.
 * */

const query = querystring.parse(location.search.slice(1));
const { a_id } = query;

export const start = () =>
  MuiF.startFrame(frame, (frame, page, tabs) => {
    /* 서버사이드 렌더링 후 동적으로 해줘야 하는 부분 */
  }).then((frame_el) => {
    try {
      if (!a_id) return;
      setTimeout(() => {
        if (UtilS.isNessApp()) {
          MShopAppCommunityF.openDetailNess({
            article_id: a_id,
            parent_cont_el: $find('.don_page', frame_el),
          });
        } else {
          MShopAppCommunityF.openDetail({ article_id: a_id, parent_cont_el: $find('.don_page', frame_el) });
        }
      }, 1000);
    } catch (_e) {
      $.alert(T('community::불러오기 실패 다시 클릭해 주세요.'));
    }
  });
